import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCatalogProductsLayeredPricesResponse, transformCatalogProductsLayeredResponse, transformCatalogProductsLayeredAttributeResponse, transformCatalogProductsSortablesResponse, transformCatalogProductsResponse, transformCatalogRecommendationProductsResponse } from './transformers.js';
import { transformCatalogProductResponse } from '../transformers/product/index.js';
import { getBaseLayered, getActiveFiltersByWhere, getPromisesLayered, getActiveFiltersLayered, getFinalLayered } from '../../utils/layered.js';
import defaultClient from 'axios';

const getCatalogProductsCount = async ({ client , controller , where ={}  })=>await client.get(`/V1/catalog/products/count`, {
        signal: controller?.signal,
        params: {
            where
        }
    });
getCatalogProductsCount.key = 'getCatalogProductsCount';
const getCatalogProductsLayeredPrices = async ({ client , controller , where ={}  } = {})=>await client.get(`/V1/catalog/products/layered/prices`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsLayeredPricesResponse)
        ]
    });
getCatalogProductsLayeredPrices.key = 'getCatalogProductsLayeredPrices';
const getCatalogProductsLayered = async ({ client , controller , where ={}  } = {})=>await client.get(`/V1/catalog/products/layered`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsLayeredResponse)
        ]
    });
getCatalogProductsLayered.key = 'getCatalogProductsLayered';
const getCatalogProductsLayeredAttribute = async ({ client , controller , attributeCode , where ={}  } = {})=>await client.get(`/V1/catalog/products/layered/${attributeCode}`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsLayeredAttributeResponse)
        ]
    });
getCatalogProductsLayered.key = 'getCatalogProductsLayeredAttribute';
const getCatalogProductsSortables = async ({ client , controller , where ={}  } = {})=>await client.get(`/V1/catalog/products/sortables`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSortablesResponse)
        ]
    });
getCatalogProductsSortables.key = 'getCatalogProductsSortables';
const getCatalogProduct = async ({ client , controller , id  } = {})=>await client.get(`/V1/catalog/products/${id}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductResponse)
        ]
    });
getCatalogProduct.key = 'getCatalogProduct';
const getCatalogProducts = async ({ client , controller , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>await client.get(`/V1/catalog/products`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsResponse)
        ]
    });
getCatalogProducts.key = 'getCatalogProducts';
const getCatalogRecommendationProducts = async ({ client , controller , sku , type  } = {})=>await client.get(`/V1/catalog/recommendation/products/${type}`, {
        signal: controller?.signal,
        params: {
            sku
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogRecommendationProductsResponse)
        ]
    });
getCatalogRecommendationProducts.key = 'getCatalogRecommendationProducts';
const getProductsLayeredAttributes = async ({ client , controller , where  })=>{
    const baseLayered = await getBaseLayered({
        client,
        controller,
        where,
        attributesMethod: getCatalogProductsLayered,
        pricesMethod: getCatalogProductsLayeredPrices
    });
    // calculate key of active filters
    const activeFilters = getActiveFiltersByWhere(where);
    const promisesLayered = getPromisesLayered({
        activeFilters,
        baseLayered,
        client,
        controller,
        where,
        attributesMethod: getCatalogProductsLayered,
        pricesMethod: getCatalogProductsLayeredPrices
    });
    // exec all promises for active filters
    const activeFiltersLayered = await getActiveFiltersLayered(promisesLayered);
    return {
        data: getFinalLayered({
            baseLayered,
            activeFiltersLayered,
            promisesLayered
        })
    };
};
getProductsLayeredAttributes.key = 'getProductsLayeredAttributes';

export { getCatalogProduct, getCatalogProducts, getCatalogProductsCount, getCatalogProductsLayered, getCatalogProductsLayeredAttribute, getCatalogProductsLayeredPrices, getCatalogProductsSortables, getCatalogRecommendationProducts, getProductsLayeredAttributes };
